import { useContext } from "react";
import { getActiveDesignFirmId, useWorkspaceStore } from "ui";
import { AuthContext } from "../../auth/Auth";
import { useFeatureFlag } from "../../featureFlags/useFeatureFlag";
import { STUDIO_LIBRARY_FLAG } from "../../libs/studioLibraryUse";

/**
 * Studio Library is a team feature: on only with the flag and a team as the
 * active workspace. The firm comes from getActiveDesignFirmId, which falls
 * back to localStorage, so a hard refresh in a team doesn't read as Personal
 * before the workspace store hydrates.
 */
export const useStudioLibraryAvailable = (): boolean => {
  const { currentUser } = useContext(AuthContext) as {
    currentUser: { uid?: string } | null;
  };
  const uid = currentUser?.uid;
  const flagOn = useFeatureFlag(STUDIO_LIBRARY_FLAG);
  // Subscribed so a workspace switch re-renders the caller.
  useWorkspaceStore((s) => (uid ? s.activeIdByUid[uid] : undefined));
  return flagOn && !!uid && getActiveDesignFirmId(uid) != null;
};
